<div *ngFor="let step of steps; let i = index" class="step">
  <div class="marker">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      [attr.fill]="styleMarker(step)"
      [attr.stroke]="markerColor"
    >
      <circle cx="12" cy="12" r="10.5" stroke-width="3" />
    </svg>
    <span class="position">
      {{ stepNumber(i) }}
    </span>
  </div>
  <div class="text">
    {{ step }}
  </div>
</div>
